module.exports = __webpack_public_path__ + "img/ic_sweet.c4e3fd91.webp";